import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import '@/assets/css/styles.css';
import '@/assets/css/styles-vuetify.css';
import '@/utils/load-image/index.js';

import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)
// import DatetimePicker from 'vuetify-datetime-picker'
// Vue.use(DatetimePicker)
import DatetimePicker from './vuetify-utils/datetime-picker'
Vue.use(DatetimePicker)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
